export default [
    {
        path: '/cetak-daftar-bmd',
        redirect: '/cetak-daftar-bmd',
        name: 'cetakDaftarBmd',
        component: () => import('@/views/NestedRoute.vue'),
        children: [
            {
                path: '',
                name: 'cetakDaftarBmdIndex',
                component: () => import('@/views/cetakDaftarBmd/Index.vue'),
                meta: {
                    action: 'Lihat',
                    resource: 'cetakDaftarBmd',
                    pageTitle: 'Cetak Daftar BMD',
                    breadcrumb: [
                        {
                            text: 'Cetak Daftar BMD',
                            active: true,
                        },
                    ],
                },
            },
        ]
    }
]